import { render } from "./Konntransacteuro.vue?vue&type=template&id=3e649e8e"
import script from "./Konntransacteuro.vue?vue&type=script&lang=js"
export * from "./Konntransacteuro.vue?vue&type=script&lang=js"

import exportComponent from "/home/smartphone/public_html/production/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__